import moment from 'moment';
import { useEffect, useState } from 'react';
import { getConsumeCost } from '../../../../api';
import { ChartSmoothLine } from '../../../../components/chart';
import getFormatMessage from '../../../../locales/get-format-message';
import {
  // ConsumeCostType,
  IBillingConsumeCost,
} from '../../../../model/billing-center';
import './style.scss';

interface IProps {
  readonly studioId: string;
}

export const RecentMonthsChartComponent = (props: IProps) => {
  const [recentMonthsList, setRecentMonthsList] =
    useState<IBillingConsumeCost[]>();
  const { studioId } = props;
  const currentMonth = moment().format('YYYY-MM-DD');
  const previousYearMonth = moment(currentMonth)
    .subtract(11, 'months')
    .startOf('month')
    .format('YYYY-MM-DD');
  const getConsumeCostData = async () => {
    try {
      const res = await getConsumeCost(
        studioId,
        previousYearMonth,
        currentMonth
      );
      if (res) {
        // console.log('近12个月消息数据res：', res);
        setRecentMonthsList(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getConsumeCostData();
  }, []);
  // 累计，排序
  const monthlyData: Record<string, number> = {};
  recentMonthsList?.forEach((item) => {
    const month = moment(item.create_time).format('YYYY-MM');
    if (monthlyData[month]) {
      monthlyData[month] += parseFloat(item.amount);
    } else {
      monthlyData[month] = parseFloat(item.amount);
    }
  });
  // 生成从previousYearMonth到currentMonth的月份
  const startMonth = moment(previousYearMonth).startOf('month');
  const endMonth = moment(currentMonth).startOf('month');
  const monthsSet: Set<string> = new Set(); // 明确指定类型为 Set<string>

  while (startMonth.isBefore(endMonth) || startMonth.isSame(endMonth)) {
    monthsSet.add(startMonth.format('YYYY-MM'));
    startMonth.add(1, 'month');
  }

  const xAxis: string[] = Array.from(monthsSet).sort(); // 转换为数组排序
  const xAxisLabels: string[] = xAxis.map((month) =>
    moment(month).format('MM')
  );
  const seriesData = xAxis.map((month) => {
    return monthlyData[month] !== undefined ? monthlyData[month] : null;
  });
  // console.log('xAxisLabels:', xAxisLabels);
  // console.log('seriesData:', seriesData);
  // const wei=[null, null, null, 11, null, null, null, null, 46.66, 72.56, 0,null];
  return (
    <div className="overview-months">
      <div className="overview-title">
        <span>{getFormatMessage('last_12_months')}</span>
      </div>
      {xAxisLabels.length > 0 && seriesData.length > 0 && (
        <ChartSmoothLine
          className="overview-months-chart"
          style={{ height: 220, width: '100%' }}
          xAxisLabel={xAxisLabels}
          seriesData={[seriesData]}
        />
      )}
    </div>
  );
};
